import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M23.44,9.55A1.5,1.5,0,0,0,22.28,9H10.42a.5.5,0,0,1-.49-.4L9.65,7.21A1.51,1.51,0,0,0,8.18,6H1.72a1.48,1.48,0,0,0-1.16.55A1.47,1.47,0,0,0,.25,7.79l2.6,13A1.51,1.51,0,0,0,4.32,22h16a1.51,1.51,0,0,0,1.47-1.21l2-10h0A1.47,1.47,0,0,0,23.44,9.55Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M3.22,5a1,1,0,0,0,1-.78A.26.26,0,0,1,4.44,4H19.72a.5.5,0,0,1,.5.5V7a1,1,0,0,0,2,0V4a2,2,0,0,0-2-2h-16a2,2,0,0,0-2,2A1,1,0,0,0,3.22,5Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }